<template>
	<div 
		v-bind:class="{ active: region.toggled }"
		v-on:click="toggle(region)"
		ref="toggleItems"
		class="accordion_item"
	>
	
		<div class="accordion_item_header">
			<span v-if="region.code" :class="getFlagClass(region.code)"></span>
			<div class="accordion_item_headline">
				{{region.name}}
			</div>
			<div v-if="region.title" class="accordion_item_subheadline">{{region.title}}</div>
		</div>
		<div class="accordion_item_body">
			<div v-if="region.image_id" class="accordion_item_image">
				<img v-bind:src="getPolopolyImgUrl(region.image_id, 'stoererbig')" v-bind:alt="(region.name)" width="100%">
				<div class="accordion_item_imageCaption">Foto: {{region.image_src}}</div>
			</div>
			<div class="accordion_item_text">
				<table>
					<tr v-if="region['Einreise']">
						<td><span class="frage">Wann darf ich einreisen?</span></td>
						<td>
							<h3 :class="region['Einreise Farbe']">{{region['Einreise']}}</h3>
							<p>{{region['Einreise Erklärtext']}}</p>
						</td>
					</tr>
					<tr v-if="region['Bewegungsfreiheit']">
						<td><span class="frage">Wann darf man sich im Land frei bewegen?</span></td>
						<td>
							<h3 :class="region['Bewegungsfreiheit Farbe']">{{region['Bewegungsfreiheit']}}</h3>
							<p>{{region['Bewegungsfreiheit Erklärtext']}}</p>
						</td>
					</tr>
					<tr v-if="region['Hotels']">
						<td><span class="frage">Wann sind Hotels wieder geöffnet?</span></td>
						<td>
							<h3 :class="region['Hotels Farbe']">{{region['Hotels']}}</h3>
							<p>{{region['Hotels Erklärtext']}}</p>
						</td>
					</tr>
				</table>
			</div> <!-- v-html="region.beschreibung" -->
		</div>
	</div>
</template>

<script>


export default {
	name: 'toggleItem',
	props: {
		region: Object
	},
	methods: {
		toggle (el) {
			console.log(el)
			el.toggled = !el.toggled
			// this.activeItem = name
		},
		getFlagClass(countryCode) {
			return 'flag-icon flag-icon-' + countryCode.toLowerCase()
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
